export default __webpack_public_path__ + "static/char-39-3a643d6e66884db354aa70943cf7f67e.gif";